import { Link } from "react-router-dom";
import styles from '../styles/pages/SiteMap.module.css';

const SiteMap = () => {
  return (
    <div>
        {/* Header Section */}
        <section className={styles.header}>
            <div className={styles.headerContent}>
                <h1 className={styles.title}>Plan du site</h1>
            </div>
        </section>
        
        {/* Content Section */}
        <section className={styles.content}>
            <ul>
                <li><Link to="/" className="links-dark">Accueil</Link></li>
                <li><Link to="/about" className="links-dark">À propos</Link></li>
                <li><Link to="/contact" className="links-dark">Contact</Link></li>
                <li><Link to="/services" className="links-dark">Services</Link></li>
                <li><Link to="/achievements" className="links-dark">Réalisations</Link></li>
                <li><Link to="/legale-notice" className="links-dark">Mentions légales</Link></li>
                <li><Link to="/site-map" className="links-dark">Plan du site</Link></li>
            </ul>
        </section>
    </div>
  );
};

export default SiteMap;
